export default __webpack_public_path__ + "133ad19960cd5dc1bd7e181b7544bcef.woff2";